import { useState } from 'react';

import { useSessionTimeout } from 'hooks/use-session-timeout';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout } from 'api/authentication-slice';

import { SessionTimeoutModal } from '../SessionTimeoutModal/SessionTimeoutModal';

export const SessionTimeoutManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [warningMsRemaining, setWarningMsRemaining] = useState(null);
  const [staySignedInLoading, setStaySignedInLoading] = useState(false);

  const { resetAfterStaySignedIn, refreshSession } = useSessionTimeout({
    enabled: true,
    onWarning: setWarningMsRemaining,
    onWarningCleared: () => setWarningMsRemaining(null),
    onExpired: async () => {
      await dispatch(logout());
      navigate('/sign_in?reason=session_expired');
    },
  });

  const handleStaySignedIn = async () => {
    setStaySignedInLoading(true);
    try {
      await refreshSession();
      resetAfterStaySignedIn();
      setWarningMsRemaining(null);
    } catch {
      // Refresh failed — leave the modal open so the countdown keeps running;
      // the next tick will either retry (if the user is active) or expire.
    } finally {
      setStaySignedInLoading(false);
    }
  };

  const handleSignOut = async () => {
    await dispatch(logout());
    navigate('/sign_in');
  };

  return (
    <SessionTimeoutModal
      visible={warningMsRemaining !== null}
      msRemaining={warningMsRemaining}
      onStaySignedIn={handleStaySignedIn}
      onSignOut={handleSignOut}
      staySignedInLoading={staySignedInLoading}
    />
  );
};
